import React, { useCallback, useState } from 'react';

import { RewardsDetailedPopupTimerOrBudget } from './timer-or-budget';
import { CashbackInfo, CashbackLevel } from '../../../../../models';
import { RewardsDetailedPopupProgressTab } from './progress-tab';
import { isMobile, resizeContent } from '../../../../../helpers';
import { RewardsDetailedPopupRulesTab } from './rules-tab';
import { RewardsDetailedPopupHeader } from './header';
import { RewardsTabs } from '../../../../../enums';
import { RewardsDetailedPopupTabs } from './tabs';

interface RewardsDetailedPopupProps {
  open: boolean;
  currency: string;
  onClose: () => void;
  cashbackInfo: CashbackInfo;
  onClaimClick: (level: CashbackLevel) => void;
  onInfoClick: (level: CashbackLevel) => void;
}

export const RewardsDetailedPopup: React.FC<RewardsDetailedPopupProps> = ({
  open,
  onClose,
  currency,
  cashbackInfo,
  onClaimClick,
  onInfoClick
}) => {

  const [activeTab, setActiveTab] = useState<RewardsTabs>(RewardsTabs.Progress);
  
  const popupRefCallback = useCallback((element: HTMLDivElement) => {
    if (element && !isMobile()) {
      resizeContent({ target: element });
      window.addEventListener('resize', () => resizeContent({ target: element }));
    }
  }, []);
  
  return (
    <div className={`rewards-wrapper ${open ? 'open' : ''}`} ref={popupRefCallback}>
      <div className="rewards-header">
        <RewardsDetailedPopupHeader onClose={onClose} />
        <RewardsDetailedPopupTimerOrBudget
          showBudget
          data={cashbackInfo}
          currencyCode={currency}
        />
        <RewardsDetailedPopupTabs
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </div>
      <div className="rewards-body-scrolled-cont">
        {
          activeTab === RewardsTabs.Progress ? (
            <RewardsDetailedPopupProgressTab
              currency={currency}
              cashbackInfo={cashbackInfo}
              onClaimClick={onClaimClick}
              onInfoClick={onInfoClick}
            />
          ) : (
            <RewardsDetailedPopupRulesTab
              data={cashbackInfo}
              currencyCode={currency}
            />
          )
        }
      </div>
    </div>
  );
};
